import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"1em"} }
const _hoisted_2 = { class: "kn-list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleButton = _resolveComponent("ToggleButton")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ToggleButton, {
        onLabel: _ctx.$t('common.expand'),
        offLabel: _ctx.$t('common.collapse'),
        onIcon: "pi pi-plus",
        offIcon: "pi pi-minus",
        style: {"width":"10em"},
        onClick: _ctx.toggleExpandCollapse
      }, null, 8, ["onLabel", "offLabel", "onClick"])
    ]),
    _createVNode(_component_Tree, {
      value: _ctx.nodes,
      expandedKeys: _ctx.expandedKeys,
      selectionMode: "single",
      selectionKeys: _ctx.preselectedNodeKey,
      "onUpdate:selectionKeys": _cache[1] || (_cache[1] = ($event: any) => (_ctx.preselectedNodeKey = $event)),
      metaKeySelection: false,
      onNodeSelect: _ctx.onNodeSelect,
      "data-test": _ctx.document - _ctx.browser - _ctx.tree
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      default: _withCtx((slotProps) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "kn-list-item-text",
            "data-test": 'document-browser-tree-item-' + slotProps.node.id
          }, [
            _createVNode("span", null, _toDisplayString(slotProps.node.name), 1)
          ], 8, ["data-test"])
        ])
      ]),
      _: 1
    }, 8, ["value", "expandedKeys", "selectionKeys", "onNodeSelect", "data-test"])
  ], 64))
}